import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './NavBar.css';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// @material-ui/icons
import Explore from '@material-ui/icons/Explore';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ListIcon from '@material-ui/icons/List';
// core components
import Header from '../Header/Header.js';
import Button from '../CustomButtons/Button.js';
import { setAuthedUser } from '../../actions/authedUser';
import { setCurrentTab } from '../../actions/currentTab';

import styles from '../../assets/jss/material-kit-react/views/componentsSections/navbarsStyle.js';

const useStyles = makeStyles(styles);

function NavBar(props) {
  const classes = useStyles();
  const { authedUser, users, currentTab } = props;
  const changeCurrentTab = tab => {
    props.dispatch(setCurrentTab(tab));
  };
  const authedUserId =
    Object.keys(users).length !== 0 && authedUser !== 'null'
      ? Object.keys(users).filter(userId => users[userId]._id === authedUser)
      : 'null';
  const authedUserName =
    authedUserId !== 'null' && authedUserId.length !== 0
      ? users[authedUserId[0]].name
      : 'There';
  const handleLogout = () => {
    props.dispatch(setAuthedUser('null'));
    props.dispatch(setCurrentTab('categories'));
    props.history.push('/');
  };
  return (
    <div style={{ minWidth: '100%' }}>
      <Header
        brand='Primary Color'
        color='navColor'
        authedUserName={authedUserName}
        rightLinks={
          <List className={classes.list}>
            <ListItem className={classes.listItem}>
              <Button
                href='/categories'
                className={
                  currentTab === 'categories'
                    ? classes.navbarLink + ' ' + classes.navbarLinkActive
                    : classes.navbarLink
                }
                color='transparent'
                onClick={() => changeCurrentTab('categories')}
              >
                <Explore className={classes.icons} style={{ color: 'white' }} />{' '}
                <span style={{ color: 'white' }}>Categories</span>
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                href='/goals'
                className={
                  currentTab === 'goals'
                    ? classes.navbarLink + ' ' + classes.navbarLinkActive
                    : classes.navbarLink
                }
                color='transparent'
                onClick={() => changeCurrentTab('goals')}
              >
                <ListIcon
                  className={classes.icons}
                  style={{ color: 'white' }}
                />{' '}
                <span style={{ color: 'white' }}>Goals</span>
              </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Button
                className={classes.navbarLink}
                onClick={handleLogout}
                color='transparent'
              >
                <ExitToAppIcon
                  className={classes.icons}
                  style={{ color: 'white' }}
                />{' '}
                <span style={{ color: 'white' }}>Sign out</span>
              </Button>
            </ListItem>
          </List>
        }
      />
    </div>
  );
}

function mapStateToProps({ authedUser, users, currentTab }) {
  return {
    authedUser,
    users,
    currentTab,
  };
}

export default withRouter(connect(mapStateToProps)(NavBar));
